import React, { Fragment, ReactNode } from 'react'
import Navigation from './Navigation'
import Footer from './Footer'

interface Props {
  children: ReactNode
}

export const Layout = ({ children }: Props) => {
  return (
    <Fragment>
      <Navigation />
      <main className='h-100' style={{ backgroundColor: '#e4f0f7', overflowY: 'scroll' }}>
        {children}
      </main>
      <Footer />
    </Fragment>
  )
}
